import computed from './computed'
import data from './data'
import components from './components'
import methods from './methods'
import mounted from './mounted'

export default {
  computed,
  data,
  components,
  methods,
  mounted,
  /* route API for professional locks */
  resourcePath: '/v1/professional/agendas/locks'
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/resources/index.js